import { logisticaTypes } from "./types"

const setTransports = (transports) => {
    return {
        type: logisticaTypes.SET_TRANSPORTS,
        payload: transports,
    }
}

const setCabeceraField = (field, value) => {
    return {
        type: logisticaTypes.SET_CABECERA_FIELD,
        payload: { field, value },
    }
}

// Varios campos de la cabecera en un solo render (transporte + patente al cambiar de transporte).
// `dirty` permite restaurar la cabecera anterior sin marcarla como modificada
const setCabeceraFields = (fields, dirty = true) => {
    return {
        type: logisticaTypes.SET_CABECERA_FIELDS,
        payload: { fields, dirty },
    }
}

// Descarta los documentos candidatos y su tilde; quedan solo las líneas guardadas de la planilla
const descartarCandidatas = () => {
    return {
        type: logisticaTypes.DESCARTAR_CANDIDATAS,
    }
}

const setFiltroDocsField =(field, value) => {
    return {
        type: logisticaTypes.SET_FILTRO_DOCS_FIELD,
        payload: { field, value },
    }
}

// Planilla guardada (DeliverySheetDTO): cabecera + todas sus líneas, de todos los estados
const loadPlanilla = (planilla) => {
    return {
        type: logisticaTypes.LOAD_PLANILLA,
        payload: planilla,
    }
}

// Facturas y transferencias candidatas; se suman a las líneas activas de la planilla cargada.
// `keepSelected` conserva los candidatos tildados que el nuevo filtro no trae
const setCandidatas = (candidatas, keepSelected = true) => {
    return {
        type: logisticaTypes.SET_CANDIDATAS,
        payload: { candidatas, keepSelected },
    }
}

// `key` es documentKey(doc): tipo + número del documento
const toggleSelected = (key) => {
    return {
        type: logisticaTypes.TOGGLE_SELECTED,
        payload: key,
    }
}

const editDocumentoField = (key, field, value) => {
    return {
        type: logisticaTypes.EDIT_DOCUMENTO_FIELD,
        payload: { key, field, value },
    }
}

const setBuscarFiltroField = (field, value) => {
    return {
        type: logisticaTypes.SET_BUSCAR_FILTRO_FIELD,
        payload: { field, value },
    }
}

const setBuscarResultados = (resultados) => {
    return {
        type: logisticaTypes.SET_BUSCAR_RESULTADOS,
        payload: resultados,
    }
}

const reset = () => {
    return {
        type: logisticaTypes.RESET,
    }
}

const toggleDrawer = () => {
    return {
        type: logisticaTypes.TOGGLE_DRAWER,
    }
}

export const logisticaActions = {
    setTransports,
    setCabeceraField,
    setCabeceraFields,
    setFiltroDocsField,
    loadPlanilla,
    setCandidatas,
    descartarCandidatas,
    toggleSelected,
    editDocumentoField,
    setBuscarFiltroField,
    setBuscarResultados,
    reset,
    toggleDrawer,
}
